import type { IntegrationDataHook } from "@/features/integrations/shared/renderer/hooks/types";

/**
 * Registry mapping integration names to their integration data hooks.
 */
const integrationDataHooksRegistry = new Map<string, IntegrationDataHook>();

/**
 * Register an integration data hook for a specific integration in the job-sync module.
 * @param integrationName - The integration name (e.g., "werkzoeken")
 * @param hook - The hook function that fetches integration-specific data
 */
export function registerJobSyncIntegrationDataHook(
  integrationName: string,
  hook: IntegrationDataHook
): void {
  const normalizedName = integrationName.toLowerCase();
  integrationDataHooksRegistry.set(normalizedName, hook);
}

/**
 * Get the registered integration data hook for an integration.
 * @param integrationName - The integration name
 * @returns The registered hook function, or undefined if not registered
 */
export function getJobSyncIntegrationDataHook(
  integrationName: string | undefined
): IntegrationDataHook | undefined {
  if (!integrationName) return undefined;
  const normalizedName = integrationName.toLowerCase();
  return integrationDataHooksRegistry.get(normalizedName);
}
